import { Tooltip, styled } from "@mui/material";
import PTTranslate from "./PTTranslate";

const StyledTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .MuiTooltip-tooltip`]: {
    backgroundColor: "#f5f5f5",
    color: theme.palette.text.primary,
    fontSize: "0.875rem",
    borderRadius: "8px",
    padding: "10px 14px",
    boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.1)",
    border: `2px solid ${theme.palette.primary.main}`,
    maxWidth: 300,
    wordBreak: "break-word",
  },
  [`& .MuiTooltip-arrow`]: {
    color: "#f5f5f5",
    "&:before": {
      border: `2px solid ${theme.palette.primary.main}`,
    },
  },
}));

export const PTTooltip = ({
  title,
  children,
  designed = false,
  placement = "top",
  arrow = true,
  sx,
  ...rest
}) => {
  const tooltipContent = <PTTranslate tk={title} />;

  if (designed) {
    return (
      <StyledTooltip
        title={tooltipContent}
        placement={placement}
        arrow={arrow}
        sx={sx}
        {...rest}
      >
        {children}
      </StyledTooltip>
    );
  }

  return (
    <Tooltip title={tooltipContent} {...rest}>
      {children}
    </Tooltip>
  );
};

export default PTTooltip;